import logo from './logo.png';
import logo2 from './logo2.png';
import logo1 from "./logo1.png"
import stone from "./stone.mp3";
import soundOn from "./soundOn.png"
import soundOff from "./soundOff.png"
import discord from "./discord.png"
import twitter from "./twitter.png"
import reddit from "./reddit.png"

import chat from "./chat.png"


import './App.css';


function App() {

  let isSoundOn;


  let soundOnON = new Audio(stone);
  let soundImg;


  
  if(localStorage.getItem("soundSetup") == "false" || localStorage.getItem("soundSetup") == "true") {

    if(localStorage.getItem("soundSetup") == "false") {

      
      isSoundOn = false;
      soundImg = soundOff;
  
    } else {

      isSoundOn = true;
      soundImg = soundOn;
  
    }

  } else {
    localStorage.setItem("soundSetup", "true")

    isSoundOn = true;
    soundImg = soundOn;
  }





  
  
/* 
<img src={logo} className="App-logo" alt="logo" />
<img src={logo2} className="App-logo2" alt="logo" />
*/

  return (
    <div className="App">
            <button onMouseEnter={() => {if(isSoundOn) { soundOnON.play(); } } } onClick={()=> {
              if(isSoundOn) {
                isSoundOn = false;
                soundImg = soundOff;
                document.getElementById("soundimg").src = soundImg;
                localStorage.setItem("soundSetup", "false")
                
              } else {
                isSoundOn = true;
                soundImg = soundOn;
                document.getElementById("soundimg").src = soundImg;
                localStorage.setItem("soundSetup", "true")


              }
            }}  id='volumeBTN'><img id="soundimg" src={soundImg} /></button>

      <header className="App-header">




      <div id='eyeLogo'>

<img src={logo1} className="App-logo" alt="logo" />


</div>

        <p >
          The Boring Ape Society, we see what others can't
        </p>
        <a 
          className="App-link"
          href="https://t.me/bettingapesociety"
        >
          <input onMouseEnter={() => {if(isSoundOn) { soundOnON.play(); } } } id="btnEnter"  value="Enter the Society" type='submit'/>
        </a>
        <div className="footer">
        
       <a 
          className="App-link"
          href="https://x.com/i/communities/1927927460102033857"
        >
        <img onMouseEnter={() => {if(isSoundOn) { soundOnON.play(); } } } className='footerImgs' src={twitter} />
     </a>
  <a 
          className="App-link"
          href="https://t.me/bettingapesociety"
        >
        <img onMouseEnter={() => {if(isSoundOn) { soundOnON.play(); } } } className='footerImgs' src={chat} />
</a>
      </div>
      </header>

  
    </div>
  );
}

/*

        <img onMouseEnter={() => {if(isSoundOn) { soundOnON.play(); } } } className='footerImgs' src={discord} />
     
        <img onMouseEnter={() => {if(isSoundOn) { soundOnON.play(); } } } className='footerImgs' src={twitter} />
     
       <img onMouseEnter={() => {if(isSoundOn) { soundOnON.play(); } } } className='footerImgs' src={reddit} /> 

        <img onMouseEnter={() => {if(isSoundOn) { soundOnON.play(); } } } className='footerImgs' src={chat} />

*/


export default App;
/*

*/